import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import SpinnerLoader from "../../../Utils/Spinner";
import "../../../assets/css/StudentShortDetails.css"; // import your CSS
import { FeeApprovalsTemplateSucessFullModal } from "../../../Component/Modals/FeeApprovalsTemplateSuccessFullModal";
import TableSkeleton from "../../../Utils/TableSkeleton";
import { getData, Postdata, PostdataWithoutToken, postDataWithToken } from "../../../API/GlobalApi";
import Notifier from "../../../Utils/notify";
import { formatDateDDMMYYYYHHMMSS_UTC } from "../../../Utils/data&dateTime";

const ImposeFeeApprovalsTemplateCourseWise = () => {
    const { uniqueId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const signature = queryParams.get("signature");
    const user_id = queryParams.get("user_id")


    const navigate = useNavigate();
    const [feePlanData, setFeePlanData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [remark, setRemark] = useState("");
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const getFeePlanData = async () => {
        try {


            const params = new URLSearchParams();
            if (signature) params.append("signature", signature);
            if (user_id) params.append("user_id", user_id);

            // Construct final URL with signature & user_id
            const finalUrl = `finance/course-fee-plans/status/${uniqueId}/?${params.toString()}`;
               

            const res = await getData(finalUrl);

            // const res = await getData(`finance/course-fee-plans/status/${uniqueId}`);



            if (res.status === "pending" && res.students) {
                const totalStudents = res.students.length;
                const feeHeadsFromSummary = res?.summary?.fee_heads_applied || [];
                const totalAmountFromFeeHeads = feeHeadsFromSummary.reduce(
                    (sum, fh) => sum + Number(fh.amount || 0),
                    0
                );

                const totalAmount =
                    totalStudents > 0
                        ? Number(res?.summary?.total_amount_all_students || 0)
                        : feeHeadsFromSummary.reduce(
                            (sum, fh) => sum + Number(fh.amount || 0),
                            0
                        );
                const mappedData = {
                    specialization: { name: res.semester_info.specialization },
                    semester: { name: res.semester_info.name },
                    created_by: res?.created_by || "N/A",
                    // feeHeads: res.fee_heads || res.students[0]?.fee_heads || [],
                    totalStudents,
                    // totalAmount: res?.summary?.total_amount_all_students || 0,
                    // ✅ correct total for course-wise
                    totalAmount,

                    // ✅ unified fee heads
                    feeHeads: feeHeadsFromSummary.map(fh => ({
                        id: fh.id,
                        name: fh.name,
                        amount: fh.amount,
                    })),
                    status: res?.status,
                    created_on: res?.current_datetime,
                };
                setFeePlanData(mappedData);
            }
        } catch (error) {
            console.error("Error fetching fee plan data:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getFeePlanData()
    }, [uniqueId])




    if (loading) {
        return (
            <div className="container">
                <div className="d-flex justify-content-center align-items-center vh-100 text-muted">
                    <TableSkeleton />
                </div>
            </div>
        );
    }


    if (!feePlanData) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 text-danger text-center impose-responsive-font">
                No fee plan details found for ID: {uniqueId}
            </div>
        );
    }

    const {
        specialization,
        semester,
        created_by,
        payments,
        students,
        total_amount,
        status,
        created_on,
        totalStudents,
        feeHeads,
        totalAmount
    } = feePlanData;


    const handleApproval = async () => {

        try {
            const url = `finance/course-fee-plans/verify/?signature=${encodeURIComponent(
                signature
            )}&user_id=${encodeURIComponent(user_id)}`;

            const payload = { unique_id: uniqueId, remark };

            const response = await PostdataWithoutToken(url, payload);


            // if (response.error) {
            //     Notifier.error(response.error);
            //     console.warn("API error details:", response.details);
            //     return;
            // }
            if (response.error || response.detail) {
                Notifier.error(response.error || response.detail);
                return;
            }

            // Redirect to thank you page
            navigate("/fee-approval-success", { state: { type: "impose" } });
        } catch (error) {
            console.error("Error approving fee plan:", error);
            Notifier.error("Something went wrong while approving the fee plan");
        }
    };


    const handleCancel = async () => {
        try {
            // signature and user_id in query string
            const url = `finance/course-fee-plans/reject/?signature=${encodeURIComponent(
                signature
            )}&user_id=${encodeURIComponent(user_id)}`;
            // Payload contains unique_id and optional remark
            const payload = {
                unique_id: uniqueId,
                remark, // include if backend supports remarks
            };
            const response = await PostdataWithoutToken(url, payload);
            if (response.error) {
                Notifier.error(response.error, response);
                return;
            }
            Notifier.success("Fee plan rejected successfully!");
            navigate("/fee-approval-cancel");
            // Redirect after reject
            // window.location.href = "/";
        } catch (error) {
            console.error("Error rejecting fee plan:", error);
            Notifier.error("Something went wrong while rejecting the fee plan");
        }
    };


    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    return (
        <>

            <div className="container py-4 impose-responsive-font">
                <h2 className="text-center mt-5 mb-4 impose-responsive-font templateFeeTitles">
                    Impose Fee Plan - Course-wise
                </h2>

                {/* Top Section */}
                <div className="row g-3 mb-4 mt-4 impose-responsive-font detailsContainer">
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Course:</strong>
                        <div>{specialization.name} ({semester.name})</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Status:</strong>
                        <div>
                            <span
                                className={`badge ${status === "pending_approval"
                                    ? "bg-warning text-dark"
                                    : status === "approved"
                                        ? "bg-success"
                                        : "bg-secondary"
                                    } impose-responsive-font badges`}

                            >
                                {status.replace("_", " ")}
                            </span>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Created By:</strong>
                        <div>{created_by}</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Created On:</strong>
                        <div> {formatDateDDMMYYYYHHMMSS_UTC(created_on)}</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">

                        <strong>Total Students:</strong> {totalStudents}
                    </div>

                    <div className="col-12 col-sm-6 col-md-3 contentDiv">

                        <strong>Total Amount:</strong> ₹{Number(totalAmount).toFixed(2)}

                    </div>

                </div>

                {/* Accordion Header */}
                <div
                    className="accordion-header d-flex justify-content-between align-items-center p-3 bg-light border rounded impose-accordion-header"
                    style={{ cursor: "pointer" }}
                    onClick={toggleAccordion}
                >
                    <h5 className="mb-0 impose-responsive-font">Fee Details</h5>
                    <span style={{ color: '#7F56DA', fontSize: '15px' }}>
                        {isAccordionOpen ? "▲" : "▼"}
                    </span>
                </div>

                {/* Accordion Content */}
                {isAccordionOpen && (
                    <div className="accordion-body mt-2">

                        <div className="table-responsive impose-table" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <table className="table table-bordered text-center mb-0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th className="text-start">Fee Head</th>
                                        <th className="text-end">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(feeHeads) && feeHeads.length > 0 ? (
                                        feeHeads.map((fh, index) => (
                                            <tr key={fh.id || index}>
                                                <td>{index + 1}</td>
                                                <td className="text-start">{fh.name}</td>
                                                <td className="text-end">
                                                    ₹{Number(fh.amount || 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-muted">
                                                No fee heads found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>



                    </div>
                )}

                {/* Remark & Buttons */}
                <div className="row g-3 align-items-end impose-buttons mt-3">
                    <div className="col-12 col-md-6">
                        {/* <label className="form-label impose-form-label">Remark</label>
                        <input
                            type="text"
                            id="remark"
                            className="form-control"
                            placeholder="Enter your remark"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                        /> */}
                    </div>

                    <div className="col-12 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center gap-2 btnContainers">
                        <button className="add-btn px-4" onClick={handleApproval}>
                            Approve
                        </button>
                        <button className="btn btn-secondary px-4" onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>


        </>
    );
};

export default ImposeFeeApprovalsTemplateCourseWise;
